export default __webpack_public_path__ + "static/media/omino_e_orologio@3x.b6fb2571.png";